export const RELATIONSHIP_TO_ATHLETE = {
  father: 'father',
  mother: 'mother',
  legalGuardian: 'legalGuardian'
}
